export default "__VITE_ASSET__a62a5305__"